import { Country } from "@lookiero/sty-psp-locale";
import { Order } from "../../../domain/entities/order/Order";
import { DEFAULT_LOCALE, LOCALE } from "../shared/config";

const formatDate = (date: string, countryCode: Country): string => {
  const locale = LOCALE[countryCode] || DEFAULT_LOCALE;

  return new Intl.DateTimeFormat(locale, {
    weekday: "short",
    day: "numeric",
    month: "long",
  }).format(new Date(date));
};

const useCountryFormattedOrderDate = (order: Order | undefined, countryCode: Country): string => {
  if (!order) {
    return "";
  }

  const intlDate = formatDate(order.datePlanned, countryCode);

  return intlDate?.charAt(0)?.toUpperCase() + intlDate?.slice(1);
};

export { useCountryFormattedOrderDate };
